//
// This module contains Esri JSAPI widgets wrapped in classes.
// As a pattern, set the actual widget as `this.widget` so that it
// can be referenced as, e.g. `Scalebar.widget`.
//

export { default as BasemapToggle } from './BasemapToggle';
export { default as PopupActionCreator } from './PopupActionCreator';
export { default as Search } from './Search';
export { default as Locate } from './Locate';



// WEBPACK FOOTER //
// ./src/esri/widgets/index.js